var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import FileUpload from "~/components/common/file-upload.vue";
import { Dependencies } from "~/core/decorator";
import { namespace } from "vuex-class";
import { CaseApplyManageService } from '~/services/business-service/case-apply-manage.service';
import { Emit, Prop } from "vue-property-decorator";
var collectionManageModule = namespace("collection-manage");
var TurnApply = /** @class */ (function (_super) {
    __extends(TurnApply, _super);
    function TurnApply() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false
        };
        _this.model = {
            caseId: _this.caseId,
            flowType: "",
            applyRemark: "",
            caseType: ""
        };
        _this.rules = {
            applyRemark: [{ required: true, message: "请输入申请说明", trigger: "blur" }]
        };
        return _this;
    }
    TurnApply.prototype.close = function () {
        var form = this.$refs["form"];
        form.resetFields();
    };
    TurnApply.prototype.commit = function () {
        var _this = this;
        var form = this.$refs["form"];
        form.validate(function (valid) {
            if (!valid)
                return;
            if (_this.otherData.caseType === 'VISIT_CASE') {
                _this.model.flowType = 'VISIT_TO_TEL';
            }
            else {
                _this.model.flowType = 'TEL_TO_VISIT';
            }
            _this.model.caseId = _this.caseId;
            _this.model.caseType = _this.otherData.caseType;
            _this.loading.state = true;
            _this.caseApplyManageService.caseApplyOperated(_this.model, _this.loading)
                .subscribe(function (data) {
                _this.$message.success("案件流转申请成功！");
                _this.close();
            });
        });
    };
    __decorate([
        Dependencies(CaseApplyManageService)
    ], TurnApply.prototype, "caseApplyManageService", void 0);
    __decorate([
        collectionManageModule.State
    ], TurnApply.prototype, "otherData", void 0);
    __decorate([
        Prop({})
    ], TurnApply.prototype, "caseId", void 0);
    __decorate([
        Emit("close")
    ], TurnApply.prototype, "close", null);
    TurnApply = __decorate([
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], TurnApply);
    return TurnApply;
}(Vue));
export default TurnApply;
